module.exports = __webpack_public_path__ + "img/hero-earth-03.9e9666b4.png";